var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('view-analytics-supplyers',{attrs:{"currentRoute":_vm.currentRoute,"currentTitle":_vm.groupingEntitySingle ? _vm.groupingEntitySingle + ' условия' : '',"tableTabs":_vm.tableTabs,"table-first-column":_vm.groupingEntityMulti}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }